export default __webpack_public_path__ + "static/media/publisherDashboard.a2c3ffb9.webp";